module.exports = __webpack_public_path__ + "img/gotop.e67d3923.svg";